import { createGlobalStyle } from "styled-components";
import { colors, fonts } from "../element/elements.js";

export const GlobalStyle = createGlobalStyle`
    html {
        font-size  : 15px;
        line-height: 1.6;
        font-family: ${fonts.roboto};
    }

    /* Texte sélectionné, sur tout le site (tour 43) : fond et couleur du texte fixés dans chaque
       thème. Avant : fond #b3d4fc sans couleur de texte, le texte clair du thème sombre devenait
       invisible. Clair : bleu canard pâle, texte foncé. Sombre : bleu clair, texte foncé. */
    ::-moz-selection {
        background : #c2e0e4;
        color      : #1e1e1e;
        text-shadow: none;
    }

    ::selection {
        background : #c2e0e4;
        color      : #1e1e1e;
        text-shadow: none;
    }

    body.dark-mode ::-moz-selection {
        background : #a5daed;
        color      : #1e1e1e;
    }

    body.dark-mode ::selection {
        background : #a5daed;
        color      : #1e1e1e;
    }

    hr {
        display   : block;
        height    : 1px;
        border    : 0;
        border-top: 1px solid ${colors.border3};
        margin    : 1em 0;
        padding   : 0;
    }

    audio,
    canvas,
    iframe,
    img,
    svg,
    video {
        vertical-align: middle;
    }

    fieldset {
        border : 0;
        margin : 0;
        padding: 0;
    }

    textarea {
        resize: vertical;
    }

    body {
        font-size     : 15px;
        letter-spacing: 0.3px;
        font-family   : ${fonts.roboto} !important;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
    }

    h1,
    h1 a {
        font-size: 40px ;
    }

    h2,
    h2 a {
        font-size: 32px;
    }

    h3,
    h3 a {
        font-size: 28px;
    }

    h4,
    h4 a {
        font-size: 24px;
    }

    h5,
    h5 a {
        font-size: 20px;
    }

    h6,
    h6 a {
        font-size: 16px;
    }

    h1, h1 a, h2, h2 a, h3, h3 a, h4, h4 a, h5, h5 a, h6, h6 a {
        font-family: ${fonts.poppins};
        margin     : 0;
    }

    a,
    button,
    li,
    p {
        font-size     : 15px;
        font-family   : ${fonts.roboto} !important;
        margin        : 0;
        letter-spacing: 0.3px;
    }

    ul {
        padding: 0;
        margin : 0;
    }

    a,
    a:active,
    a:focus,
    a:hover,
    button:focus,
    button:hover {
        text-decoration: none!important;
        outline        : none;
    }

    a,
    button {
        transition: all 0.2s ease;
    }

    a{
        color:black
    }
    input:focus,
    textarea:focus {
        outline: none;
    }

    body.light-mode {
        background-color: #ffffff !important;
        color: #000000 !important;
    }

    body.dark-mode {
        background-color: #1e1e1e !important;
        color: #e4e6eb !important;
    }

    .light-mode {
        color-scheme: light;
    }

    .dark-mode {
        color-scheme: dark;

        ul.dropdown,.bg-white{
            background-color: #1e1e1e !important;
            color: #e4e6eb !important;
        }
        .input-field{
            background-color: #333 !important;
            color:#e4e6eb !important;
            border: 1px solid rgb(68 68 68)!important;
            ::placeholder {
                color: #e4e6eb;
            }
        }
        
        .form-check-input:checked{
            background-color: ${colors?.orange} !important;
        }
        textarea{
            background-color: rgb(70 68 68) !important;
            color:#e4e6eb !important;
            ::placeholder {
                color: #e4e6eb;
            }
        }
        .shadow-lg{
            box-shadow: rgb(108 108 108 / 83%) 0px 1px 6px !important;
        }
        .shadow{
            box-shadow: rgb(84 84 84 / 68%) 1px 3px 10px !important;
        }
        .shadow-sm{
            box-shadow: rgb(84 84 84 / 68%) 1px 3px 5px !important;
            background: #1e1e1e;
        }
        .modal-content{
            background-color: #333 !important;
            border-radius:5px;
        }
        .css-12iiol5-control,.css-1g3p1vi-control{
            background-color: #333 !important;
            color:#e4e6eb !important;
            input{
                background:none !important;
                border:none !important;
            }
        }
        a{
            color:#fff
        }
    } //   dark mode end

    ::-webkit-scrollbar {
        width: 5px;
        border-radius:10px;
    }
    ::-webkit-scrollbar-track {
        background-color: #dadada; 
        border-radius:5px;
    }
    ::-webkit-scrollbar-thumb {
        background-color: ${colors?.darkblue}; 
        border-radius: 6px; 
    }
    ::-webkit-scrollbar-thumb:hover {
        background-color: ${colors?.darkbluehover};
    }
    .controlskit[_ngcontent-ng-c2939039469]{
        background: #fdfdfd00 !important;
    }

    /* 🐢 « Réduire les animations » réglé sur l'appareil : plus aucune animation ni transition, sur tout
       le site (tour 50). Elles finissent tout de suite sur leur dernier état
       (courbes tracées, contenus affichés). 0,01 ms plutôt que 0 : les fenêtres de Bootstrap attendent
       la fin de leur transition pour s'ouvrir et se fermer */
    @media (prefers-reduced-motion: reduce) {
        *, *::before, *::after {
            animation-duration: 0.01ms !important;
            animation-iteration-count: 1 !important;
            animation-delay: 0s !important;
            transition-duration: 0.01ms !important;
            transition-delay: 0s !important;
            scroll-behavior: auto !important;
        }
    }
`;